var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('topbar'),_vm._v(" "),_c('div',{staticClass:"wrapper-list gb-wrapper"},[_c('div',{staticClass:"wrapper-in"},[_c('header1'),_vm._v(" "),_c('div',{staticClass:"content"},[_c('commonSidebar'),_vm._v(" "),_c('mainContentList')],1),_vm._v(" "),_c('commonFooter')],1),_vm._v(" "),_c('vueToTop')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-018be23f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/strateList.vue
// module id = null
// module chunks = 